module.exports = __webpack_public_path__ + "static/media/IMG_0012.ca951d0e.jpg";